<template>
	<div>
		<div id="Comment">
			<van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
				<van-list v-model="isLoading" :finished="isFinished" @load="onLoad">
					<div v-for="item in list" :key="item.id">
						<div class="item">
							<van-row type="flex">
								<img v-if="item.avatar == ''" src="../../assets/skyworth.png" fit="cover" class="logo" />
								<van-image v-else :src="item.avatar" fit="cover" class="logo"></van-image>
								<div class="content-container">
									<div class="name">{{ item.real_name }}</div>
									<div class="content">{{ item.content }}</div>
									<div class="time">{{ item.time }}</div>
								</div>
							</van-row>
							<van-divider />
						</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
		<div id="tool">
			<van-row type="flex" justify="space-between">
				<van-col span="20">
					<van-field class="fieldClass" v-model="text" placeholder="写下你的评论" maxlength="128" @blur="delayOnblur" @focus="showApplyActivity = false" />
				</van-col>
				<van-col id="comment-icon" span="4" v-if="showApplyActivity"> <van-icon size="1.5625rem" name="comment-o" />{{ comment_count }} </van-col>
				<van-col class="apply-btn-box" span="4" v-else>
					<van-button class="apply-btn" block size="large" type="info" @click="submitComment">发布</van-button>
				</van-col>
			</van-row>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import toastLoading from '../../util/toastLoading'
export default {
	props: ['type', 'comment_count', 'item', 'is_open'],
	data() {
		return {
			isLike: false,
			text: '',
			list: [],
			pageNo: 1,
			pageSize: 20,
			isRefresh: false,
			isLoading: false,
			isFinished: false,
			user_id: null,
			showApplyActivity: true,
			status: this.item.status,
		}
	},
	computed: {
		isOpen() {
			return this.is_open
		},
		...mapGetters(['token', 'userId', 'companyId']),
	},
	methods: {
		async submitComment() {
			if (!this.isOpen) {
				this.$toast('评论已关闭')
				return
			}
			if (this.text.trim() == '') {
				this.$toast('请输入评论内容')
				return
			}

			toastLoading.showLoading('加载中...')

			try {
				let parmas = {
					type: this.type,
					topic_id: this.$route.query.id,
					user_id: this.user_id,
					content: this.text,
				}
				await this.vaxios.postApi(`${this.vaxios.host}/api/v1/discusses/common`, parmas)
				toastLoading.clearLoading()
				this.$toast('评论成功')
				this.text = ''
				this.onRefresh()
				this.$emit('getdata')
			} catch (_) {
				toastLoading.clearLoading()
			}
		},
		onRefresh() {
			this.list = []
			this.pageNo = 1
			this.onLoad()
			this.isRefresh = false
		},
		async onLoad() {
			toastLoading.showLoading('加载中...')
			let parmas = {
				pageNo: this.pageNo,
				pageSize: this.pageSize,
			}
			try {
				let res = await this.vaxios.getApi(`${this.vaxios.host}/open/api/v1/discusses/topic/${this.$route.query.id}/commons`, parmas)
				toastLoading.clearLoading()
				if (res.code !== 1 || !res.data) return
				let data = res.data.list
				data.forEach((item) => {
					this.list.push({
						id: item.id,
						name: item.user_id,
						content: item.content,
						time: moment(parseInt(item.update_time)).format('YYYY-MM-DD HH:mm:ss'),
						avatar: item.avatar || '',
						real_name: item.real_name || item.user_id,
					})
				})

				// 加载状态结束
				this.pageNo++
				this.isLoading = false
				this.isFinished = this.list.length >= res.data.total
			} catch (_) {
				toastLoading.clearLoading()
			}
		},
		delayOnblur() {
			let timer = setTimeout(() => {
				this.showApplyActivity = true
				clearTimeout(timer)
			}, 100)
		},
	},
}
</script>

<style>
#Comment {
	margin-left: 1rem;
	width: 90%;
}

.item {
	width: 100%;
}

.logo {
	width: 1.5rem;
	height: 1.5rem;
}

.name {
	color: #272727;
	font-size: 0.9375rem;
	margin-left: 20px;
}

.content {
	min-height: 3.125rem;
	margin-top: 0.34375rem;
	color: #272727;
	font-size: 1rem;
	font-weight: 500;
	margin-left: 20px;
}

.time {
	margin-top: 0.34375rem;
	color: #8d8d8d;
	font-size: 0.75rem;
	margin-left: 20px;
}

#tool {
	width: 100%;
	height: 50px;
	background-color: #ffffff;
	position: fixed;
	bottom: 0px;
	border-top: 1px solid rgba(0, 0, 0, 0.08);
	margin-left: -1rem;
	margin-bottom: 5px;
}

.van-list .van-divider {
	margin-top: 0.96875rem;
	margin-bottom: 0.875rem;
	padding: 0;
}

.fieldClass {
	margin-left: 8px;
}

#like-icon,
#comment-icon {
	text-align: center;
	font-size: 0.6875rem;
	margin-top: 0.875rem;
}
.apply-btn-box {
	padding: 8px 10px 8px 0;
}

.apply-btn {
	height: 100%;
	width: 100%;
}

#tool .van-cell {
	padding: 0;
}

.van-field__control {
	height: 2rem;
	background-color: #f6f6f6;
	border-radius: 1.125rem;
	font-size: 1rem;
	padding-left: 1rem;
	margin: 0.65625rem 1rem 0.65625rem 1rem;
}

.van-list__finished-text {
	background-color: #f5f5f5;
	margin-bottom: 3.28125rem;
}

.loading {
	display: flex;
	justify-content: center;
}
</style>
